<template>
  <div class="app-container dashboard-channel-matrix">
    <!-- 渠道矩阵卡片 -->
    <el-card shadow="never" class="mb18">
      <div class="cust-toolbar">
        <div class="cust-left card-hd" style="gap: 10px">
          <span class="bar"></span>
          <span class="t">下游渠道 × 酒店 销量透视</span>
          <span class="s"
            >行=下游渠道，列=Top酒店，单元格=销量（按当前指标）</span
          >
        </div>
        <div class="cust-right">
          <el-input
            v-model="searchText"
            placeholder="搜索下游渠道"
            size="small"
            style="width: 180px"
            clearable
            @input="handleSearch"
          />
          <el-radio-group
            v-model="metric"
            size="small"
            style="margin-left: 10px"
            @change="handleMetricChange"
          >
            <el-radio-button label="nights">销量(间夜)</el-radio-button>
            <el-radio-button label="revenue">营业额</el-radio-button>
          </el-radio-group>
          <el-button
            type="primary"
            size="small"
            icon="el-icon-download"
            :disabled="!matrixData || !matrixData.rows.length"
            @click="openExport"
            style="margin-left: 10px"
            >导出</el-button
          >
        </div>
      </div>

      <!-- 矩阵表格 -->
      <div style="overflow-x: auto">
        <table class="mtx" v-if="matrixData">
          <thead>
            <tr>
              <th class="mtx-rowhdr">下游渠道＼酒店</th>
              <th
                v-for="col in matrixData.cols"
                :key="col.name"
                class="mtx-col"
                :title="col.name"
              >
                {{ formatColName(col) }}
              </th>
              <th class="mtx-tot">合计</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in paginatedRows" :key="row">
              <td class="mtx-rowhdr">{{ row }}</td>
              <td
                v-for="col in matrixData.cols"
                :key="col.name"
                class="mtx-cell"
                :style="getCellStyle(row, col.name)"
              >
                {{ formatCell(row, col.name) }}
              </td>
              <td class="mtx-tot">{{ formatRowTotal(row) }}</td>
            </tr>
            <tr class="mtx-grand">
              <td class="mtx-rowhdr">合计</td>
              <td
                v-for="col in matrixData.cols"
                :key="col.name"
                class="mtx-cell"
              >
                {{ formatColTotal(col.name) }}
              </td>
              <td class="mtx-tot">{{ formatGrandTotal() }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 图例 -->
      <div class="mtx-legend">
        <span>销量低</span>
        <i class="lg" style="background: rgba(64, 158, 255, 0.16)"></i>
        <i class="lg" style="background: rgba(64, 158, 255, 0.34)"></i>
        <i class="lg" style="background: rgba(64, 158, 255, 0.52)"></i>
        <i class="lg" style="background: rgba(64, 158, 255, 0.72)"></i>
        <i class="lg" style="background: rgba(64, 158, 255, 0.9)"></i>
        <span>销量高</span>
        <span style="margin-left: 16px; color: #909399; font-size: 12px">
          颜色越深销量越高；空白格（—）= 该下游渠道未采购此酒店
        </span>
      </div>

      <!-- 分页 -->
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 12px;
        "
      >
        <span style="font-size: 12px; color: #909399"
          >共 {{ filteredRows.length }} 个下游渠道</span
        >
        <el-pagination
          @current-change="handlePageChange"
          @size-change="handleSizeChange"
          :current-page="currentPage"
          :page-size="pageSize"
          :total="filteredRows.length"
          :page-sizes="[10, 20, 50]"
          layout="total, sizes, prev, pager, next, jumper"
          small
          background
        />
      </div>

      <!-- 导出弹窗 -->
      <el-dialog
        title="导出渠道矩阵"
        :visible.sync="exportDialogVisible"
        width="440px"
      >
        <div style="font-size: 13px; color: #606266; line-height: 1.9">
          <p style="margin: 0 0 14px">
            当前矩阵默认展示销量
            <b>{{ matrixData ? matrixData.cols.length : 0 }}</b>
            家酒店；可导出排名更靠前的更多酒店（最多 {{ matrixHotels.length }} 家）。
          </p>
          <el-form label-width="130px" size="small">
            <el-form-item label="导出前 N 家酒店">
              <el-input-number
                v-model="exportTopN"
                :min="1"
                :max="exportMaxHotelCount"
                :step="1"
                controls-position="right"
                style="width: 170px"
              />
            </el-form-item>
            <el-form-item label="导出指标">
              <el-radio-group v-model="metric">
                <el-radio-button label="nights">销量(间夜)</el-radio-button>
                <el-radio-button label="revenue">营业额</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer">
          <el-button size="small" @click="exportDialogVisible = false"
            >取消</el-button
          >
          <el-button type="primary" size="small" @click="doExport"
            >确认导出 Excel</el-button
          >
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import request from '@/utils/request'
import * as XLSX from 'xlsx'

export default {
  name: 'DashboardChannelMatrix',
  data() {
    return {
      searchText: '',
      metric: 'nights', // nights | revenue
      matrixData: null,
      hotels: [],
      currentPage: 1,
      pageSize: 10,
      exportDialogVisible: false,
      exportTopN: 10,
    }
  },
  computed: {
    matrixHotels() {
      return this.hotels.filter((hotel) => hotel.custs.length)
    },
    exportMaxHotelCount() {
      return Math.max(1, this.matrixHotels.length)
    },
    filteredRows() {
      if (!this.matrixData) return []
      if (!this.searchText) return this.matrixData.rows
      const q = this.searchText.trim().toLowerCase()
      return this.matrixData.rows.filter((r) => r.toLowerCase().indexOf(q) >= 0)
    },
    paginatedRows() {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      return this.filteredRows.slice(start, end)
    },
  },
  created() {
    this.fetchHotels()
  },
  methods: {
    fetchHotels() {
      request({
        url: '/api/backend/dataCount/hotelList',
        method: 'get',
      })
        .then((response) => {
          const payload = response.data || []
          const list = Array.isArray(payload) ? payload : payload.data || []
          this.hotels = list.map(this.normalizeHotel)
          this.buildMatrix()
        })
        .catch(() => {
          this.hotels = []
          this.matrixData = null
          this.$message.error('获取酒店数据失败')
        })
    },

    normalizeHotel(hotel) {
      const custs = Array.isArray(hotel.custs)
        ? hotel.custs.filter(Boolean)
        : []

      return {
        ...hotel,
        name: hotel.name || hotel.hotel_name || '未命名酒店',
        city: hotel.city || '-',
        nights: parseInt(hotel.nights || 0, 10),
        revenue: parseFloat(hotel.revenue) || 0,
        custs,
      }
    },

    handleSearch() {
      this.currentPage = 1
    },

    handleMetricChange() {
      // 切换指标不需要重新请求，前端直接使用当前数据切换显示
    },

    handlePageChange(page) {
      this.currentPage = page
    },

    handleSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
    },

    // 构建矩阵数据
    buildMatrix() {
      const cols = this.getTopHotels(10)
      this.matrixData = this.createMatrix(cols)
      this.currentPage = 1
    },

    getTopHotels(topN) {
      return [...this.matrixHotels]
        .sort((a, b) => b.nights - a.nights)
        .slice(0, topN)
    },

    createMatrix(cols) {
      // 收集所有下游渠道
      const rowSet = []

      const raw = {}
      const rowTotN = {}
      const rowTotR = {}
      const colTotN = {}
      const colTotR = {}
      let grandN = 0
      let grandR = 0
      let maxN = 0
      let maxR = 0

      cols.forEach((h) => {
        // 使用酒店数据中的 custs 字段作为采购渠道
        const buyers = h.custs || []

        if (!buyers.length) return

        // 按hash分配销量
        const ws = buyers.map(
          (c) => 1 + (Math.abs(this.strHash(c + h.name)) % 6),
        )
        const wsum = ws.reduce((a, b) => a + b, 0)

        buyers.forEach((c, i) => {
          const share = ws[i] / wsum
          const n = Math.round(h.nights * share)
          const r = Math.round(h.revenue * share)

          raw[c] = raw[c] || {}
          raw[c][h.name] = { nights: n, revenue: r }

          rowTotN[c] = (rowTotN[c] || 0) + n
          rowTotR[c] = (rowTotR[c] || 0) + r
          colTotN[h.name] = (colTotN[h.name] || 0) + n
          colTotR[h.name] = (colTotR[h.name] || 0) + r

          grandN += n
          grandR += r
          if (n > maxN) maxN = n
          if (r > maxR) maxR = r

          if (!rowSet.includes(c)) rowSet.push(c)
        })
      })

      // 渠道按总间夜排序
      const rows = rowSet
        .slice()
        .sort((a, b) => (rowTotN[b] || 0) - (rowTotN[a] || 0))

      return {
        cols,
        rows,
        raw,
        rowTotN,
        rowTotR,
        colTotN,
        colTotR,
        grandN,
        grandR,
        maxN,
        maxR,
      }
    },

    strHash(s) {
      let h = 0
      for (let k = 0; k < s.length; k++) {
        h = (h * 31 + s.charCodeAt(k)) >>> 0
      }
      return h
    },

    formatColName(col) {
      return String(col.name || '').split('(')[0] + '·' + (col.city || '-')
    },

    getCellStyle(row, name) {
      const cell = (this.matrixData.raw[row] || {})[name]
      if (!cell) {
        return { background: '#f5f7fa', color: '#c0c4cc' }
      }
      const v = this.metric === 'nights' ? cell.nights : cell.revenue
      const max =
        this.metric === 'nights' ? this.matrixData.maxN : this.matrixData.maxR
      const t = max ? v / max : 0
      return {
        background: `rgba(64,158,255,${(0.06 + 0.74 * t).toFixed(3)})`,
        color: t > 0.55 ? '#fff' : '#303133',
        fontWeight: 600,
      }
    },

    formatCell(row, name) {
      const cell = (this.matrixData.raw[row] || {})[name]
      if (!cell) return '—'
      const v = this.metric === 'nights' ? cell.nights : cell.revenue
      return this.metric === 'nights'
        ? this.formatNumber(v)
        : '¥' + this.formatNumber(v)
    },

    formatRowTotal(row) {
      const v =
        this.metric === 'nights'
          ? this.matrixData.rowTotN[row]
          : this.matrixData.rowTotR[row]
      return this.metric === 'nights'
        ? this.formatNumber(v)
        : '¥' + this.formatNumber(v)
    },

    formatColTotal(name) {
      const v =
        this.metric === 'nights'
          ? this.matrixData.colTotN[name]
          : this.matrixData.colTotR[name]
      return this.metric === 'nights'
        ? this.formatNumber(v)
        : '¥' + this.formatNumber(v)
    },

    formatGrandTotal() {
      const v =
        this.metric === 'nights'
          ? this.matrixData.grandN
          : this.matrixData.grandR
      return this.metric === 'nights'
        ? this.formatNumber(v)
        : '¥' + this.formatNumber(v)
    },

    openExport() {
      if (!this.matrixData || !this.matrixData.rows.length) return
      this.exportTopN = Math.min(
        this.matrixData.cols.length || 10,
        this.exportMaxHotelCount,
      )
      this.exportDialogVisible = true
    },

    doExport() {
      if (!this.matrixData || !this.matrixData.rows.length) return
      const topN = this.exportTopN
      const cols = this.getTopHotels(topN)
      const exportMatrix = this.createMatrix(cols)
      const rows = this.searchText
        ? exportMatrix.rows.filter(
            (r) =>
              r.toLowerCase().indexOf(this.searchText.trim().toLowerCase()) >=
              0,
          )
        : exportMatrix.rows
      const metric = this.metric

      // 构建导出数据
      const data = []
      // 表头
      const headerRow = ['下游渠道', ...cols.map((c) => c.name), '合计']
      data.push(headerRow)

      // 数据行
      rows.forEach((r) => {
        const rt =
          metric === 'nights'
            ? exportMatrix.rowTotN[r] || 0
            : exportMatrix.rowTotR[r] || 0
        const rowData = [r]
        cols.forEach((c) => {
          const cell = (exportMatrix.raw[r] || {})[c.name]
          const v = cell
            ? metric === 'nights'
              ? cell.nights
              : cell.revenue
            : 0
          rowData.push(v)
        })
        rowData.push(rt)
        data.push(rowData)
      })

      // 创建工作簿
      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.aoa_to_sheet(data)

      // 设置列宽
      ws['!cols'] = [
        { wch: 20 }, // 下游渠道
        ...cols.map(() => ({ wch: 16 })), // 酒店列
        { wch: 12 }, // 合计列
      ]

      XLSX.utils.book_append_sheet(wb, ws, '渠道矩阵')
      XLSX.writeFile(wb, '渠道矩阵_前' + topN + '家酒店.xlsx')

      this.exportDialogVisible = false
      this.$message.success(
        '已导出前 ' + topN + ' 家酒店 × ' + rows.length + ' 个下游渠道',
      )
    },

    formatNumber(val) {
      return parseFloat(val || 0).toLocaleString('zh-CN')
    },
  },
}
</script>

<style lang="scss" scoped>
.dashboard-channel-matrix {
  .mb18 {
    margin-bottom: 18px;
  }

  .filter-container {
    background: #fff;
    border-radius: 6px;
    padding: 16px 20px;
    margin-bottom: 18px;
  }

  .cust-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
  }
  .cust-left {
    display: flex;
    align-items: center;
    gap: 14px;
  }
  .cust-right {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .card-hd {
    display: flex;
    align-items: center;
    gap: 8px;
    .bar {
      width: 3px;
      height: 15px;
      border-radius: 2px;
      background: #409eff;
      flex-shrink: 0;
    }
    .t {
      font-size: 15px;
      font-weight: 600;
      color: #1f2733;
    }
    .s {
      font-size: 12px;
      color: #8a94a6;
      margin-left: 2px;
    }
  }

  .mtx {
    border-collapse: separate;
    border-spacing: 0;
    width: 100%;
    font-size: 12px;
    min-width: 780px;
  }
  .mtx th,
  .mtx td {
    border: 1px solid #ebeef5;
    padding: 7px 6px;
    text-align: center;
    vertical-align: middle;
  }
  .mtx thead th {
    background: #f3f6fb;
    color: #5b6472;
    font-weight: 600;
  }
  .mtx .mtx-col {
    width: 104px;
    white-space: normal;
    line-height: 1.25;
    color: #606266;
    font-weight: 600;
  }
  .mtx .mtx-rowhdr {
    background: #fafafa;
    color: #303133;
    font-weight: 600;
    text-align: left;
    white-space: nowrap;
    position: sticky;
    left: 0;
    z-index: 2;
  }
  .mtx .mtx-cell {
    font-variant-numeric: tabular-nums;
    font-size: 12px;
    transition: background 0.2s;
  }
  .mtx .mtx-tot {
    background: #fff7e6;
    color: #b88230;
    font-weight: 700;
    border-left: 2px solid #f0c97a;
  }
  .mtx .mtx-grand td {
    background: #fdf0d5;
    font-weight: 700;
    color: #a8650f;
    border-top: 2px solid #f0c97a;
  }
  .mtx tbody tr:hover td.mtx-cell {
    filter: brightness(0.97);
  }

  .mtx-legend {
    display: flex;
    align-items: center;
    gap: 5px;
    margin-top: 14px;
    font-size: 12px;
    color: #909399;
  }
  .mtx-legend .lg {
    width: 26px;
    height: 10px;
    border-radius: 2px;
  }
}
</style>
